<template>
<div class="myBusiness">
    <myBusinessList v-if="user.providerstatus == 10" :hostroletype="hostroletype"></myBusinessList>
    <serviceProviderTip v-else></serviceProviderTip>
</div>
</template>providerstatus

<script>
import {mapGetters, mapActions} from 'vuex'
import MyBusinessList from 'views/serviceProvider/myBusiness/MyBusinessList.vue'
import ServiceProviderTip from 'views/serviceProvider/components/serviceProviderTip.vue'
export default {
    name: 'myBusiness',
    data() {
        return {
            hostroletype: 4
        }
    },
    mounted() {
    },
    methods: {},
    filters: {

    },
    watch: {},
    computed: {
        ...mapGetters(['user'])
    },
    components: {
        MyBusinessList, ServiceProviderTip
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.myBusiness {
}
</style>
